<template>
  <div class="purchase-history">
    <div class="history-header" v-if="$route.query.isApp!=1">
      <i @click="$router.go(-1)"  class="iconfont icon-left" :class="{mirrorRotateLevel:isDirection}"></i>
      <span class="bold">{{$t("300320")}}</span>
    </div>
    <div class="history-main">
      <div class="history-tab">
        <van-tabs @click="onClick" v-model="name" swipe-threshold="4">
          <van-tab :name="name" v-for="({name,title},index) in tab" :title="title" :key="index"></van-tab>
        </van-tabs>
      </div>
      <div class="data-content">
        <van-list
          offset="50"
          v-model="loading"
          v-if="historyData.length>0"
          :finished="finished"
          loading-text=" "
          :finished-text="name===3?`—${$t('300330')}—`:''"
          @load="onLoad"
        >
          <ul v-if="name==5 && current == name" class="joinHistory">
            <li class="listHeader">
              <span>{{$t('300321')}}</span>
              <span>{{$t('300322')}}</span>
            </li>
            <li v-for="(item,index) in historyData" :key="index">
              <span>{{parseTime(item.createTime)}}</span>
              <span>{{item.snapshotTitle}}</span>
            </li>
          </ul>
          <ul v-if="name==3 && current == name" class="Participated">
            <li class="Participated-header">
              <span>{{$t('300321')}}</span>
              <span>{{$t('300322')}}</span>
              <span>{{$t('300323')}}</span>
            </li>
            <li v-for="(item,index) in historyData" :key="index">
              <span>{{parseTime(item.createTime)}}</span>
              <span>{{item.snapshotTitle}}</span>
              <span>{{item.buyCount}}</span>
            </li>
          </ul>
          <!-- <p class="footTip"></p> -->
          <ul v-if="name==2 && current == name" class="Refunded">
            <li class="Refunded-header">
              <span>{{$t('300321')}}</span>
              <span>{{$t('300322')}}</span>
              <span>{{$t('300324')}}</span>
            </li>
            <li v-for="(item,index) in historyData" :key="index">
              <span>{{parseTime(item.createTime)}}</span>
              <span>{{item.snapshotTitle}}</span>
              <span>{{item.buyPrice}}{{item.currency.toUpperCase()}}</span>
            </li>
          </ul>
          <ul v-if="name==4 && current == name" class="unclaimed">
            <li class="unclaimed-header">
              <span>{{$t('300321')}}</span>
              <span>{{$t('300322')}}</span>
              <span>{{$t('300325')}}</span>
            </li>
            <li v-for="(item,index) in historyData" :key="index">
              <span>{{parseTime(item.createTime)}}</span>
              <span>{{item.snapshotTitle}}</span>
              <span @click="goToGetIt" class="draw">
                <em>{{$t('300326')}}</em>
                <i :class="{mirrorRotateLevel:isDirection}" class="iconfont icon-gengduo"></i>
              </span>
            </li>
          </ul>
          <ul v-if="name==1 && current == name" class="announced">
            <li class="unclaimed-header">
              <span>{{$t('300321')}}</span>
              <span>{{$t('300322')}}</span>
              <span>{{$t('300323')}}</span>
            </li>
            <li v-for="(item,index) in historyData" :key="index">
              <span>{{parseTime(item.createTime)}}</span>
              <span>{{item.snapshotTitle}}</span>
              <span>{{item.buyCount}}</span>
            </li>
          </ul>
        </van-list>
        <div class="historyno" v-else>
          <van-empty :description="getDescription()">
            <svg slot="image" class="icon empty-icon" aria-hidden="true">
              <use xlink:href="#icon-jilu1" />
            </svg>
          </van-empty>
        </div>
      </div>
    </div>
    <van-popup class="tipModel" :close-on-click-overlay="false" v-model="getPrize">
      <p class="p">
        <svg>
          <use xlink:href="#icon-tishi-1" />
        </svg>
      </p>
      <p class="describe inline-block">{{$t('300315')}}</p>
      <div class="sell inline-block">
        <van-button @click="getPrize=false">{{$t('300286')}}</van-button>
      </div>
    </van-popup>
       <van-popup class="prizeModel" :close-on-click-overlay="false" v-model="prizeModel">
      <p class="p">
        <!-- 恭喜您 -->
         <img
          class="mirrorRotateLevel"
          src="../../../static/images/congratulations.png"
          alt
        />
        {{$t('300310')}}
       <img src="../../../static/images/congratulations.png" alt />
      </p>
      <p class="shopName bold">{{prizeMessage.snapshotTitle}}</p>
      <p class="prizeImage">
        <img src="../../../static/images/Issued.png" alt />
      </p>
      <div class="btn inline-block" v-if='$route.query.isApp==1'>
        <van-button class="bold" @click='showOff'>{{$t('300346')}}</van-button>
        <!-- 炫耀一下 -->
      </div>
      <van-button class="bold checkGift" v-if='$route.query.isApp==1' @click="toLook">{{$t('300351')}}</van-button>
        <div class="btn inline-block" v-if='$route.query.isApp!=1' @click="toLook">
        <van-button class="bold" @click='showOff'>{{$t('300351')}}</van-button>
        <!-- 炫耀一下 -->
      </div>
      <div class="close">
        <svg @click="closePrize">
          <use xlink:href="#icon-guanbi2" />
        </svg>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Tab, Tabs, List, Cell, Empty, Popup,Button, Toast } from 'vant'
import { getShopStore,checkIssuedTakeNotes,ViewedTakeNotes} from "./api"
import { parseTime } from '../../utils'
import { mapGetters } from 'vuex'
export default {
  components: {
    VanTabs: Tabs,
    VanTab: Tab,
    VanList: List,
    VanCell: Cell,
    VanEmpty: Empty,
    VanPopup: Popup,
    VanButton:Button
  },
  data() {
    return {
      tab: [{ title: this.$t('300288'), name: 1 }, { title: this.$t('300289'), name: 4 }, { title: this.$t('300173'), name: 5 }, { title: this.$t('300290'), name: 3 }, { title: this.$t('300291'), name: 2 }],
      name: 1,
      historyData: [],
      loading: false,
      finished: false,
      total: 0,
      ind: 1,
      tipMessage:'',
      prizeModel:false,
      getPrize: false,
      prizeMessage:{
        snapshotTitle:''
      },
      sign:'',
      current:1
    }
  },
  created() {
    this.name = this.$route.query.name*1||this.name
    this.sign = this.$route.query.name*1||this.name
    this.getShopStore();
      window.document.documentElement.setAttribute(
        "dir",
        this.isDirection ? "rtl" : "ltr"
      ); 
    // console.log(this.isApp)
    this.checkTakeNotes()
  },
  computed:{
    ...mapGetters(['isApp','isDirection'])
  },
  methods: {
    getDescription() {
        if (this.name === 3) {
        return this.$t('300330');
        } else {
        return this.$t('300108');
        }
    },
    toLook(){
      this.name=5;this.prizeModel=false;
      this.ind = 1
      this.ViewedTakeNotes();
      this.getShopStore()
    },
    showOff(){
      this.ViewedTakeNotes()
      this.$jsBridge.callHandler(
        this.$jsBridgeCmd.appShowOff,
        {
          code: 200,
          title: this.prizeMessage.share||'',
          url:window.location.origin+'/purchase',
          text: this.prizeMessage.highlighting||'',
          join:this.$t('300347')
        },
        data => {}
      );
    },
    ViewedTakeNotes(){
      ViewedTakeNotes({id:this.prizeMessage.id})  
    },
    checkTakeNotes(){
      checkIssuedTakeNotes().then(res=>{
        if(res.data){
          this.prizeMessage = res.data;
          this.prizeModel = true
        }
       
      })
    },
    closePrize() {//中将弹框
      this.prizeModel = false;
      this.ViewedTakeNotes()
    },
    goToGetIt() {
      // this.getPrice = true
      // console.log(this.isApp)
      if(this.isApp==1||this.$route.query.isApp==1){ 
      this.$jsBridge.callHandler(
        this.$jsBridgeCmd.appCustomerService,
        {
          code: 200,
          active:window.location.href.toString().split("?")[0] 
        },
        data => {
        }
      );
      }else{
       this.getPrize = true;
      }
    },
    onLoad() {
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      this.loading = true;
      setTimeout(() => {
        if (this.historyData.length === this.total) {
          this.finished = true;
           this.loading = false;
          return
        }
        this.ind++;
        getShopStore({ status: this.name, page: this.ind, pageSize: 15 }).then(res => {
          this.historyData = this.historyData.concat(res.data.items)
          this.total = res.data.total
        })
        // 加载状态结束
        this.loading = false;
        // 数据全部加载完成

      }, 1000);
    },
    onClick(name, active) {
      if(this.sign==name)return
      this.current = 0
      this.name = name
      this.sign = name
      this.finished = false
      this.ind = 1;
      this.historyData = []
      this.getShopStore(name)
    },
    parseTime(time) {
      return parseTime(time)
    },
    getShopStore(name) {
      getShopStore({ status: this.name, page: this.ind, pageSize: 15 }).then(res => {
        this.historyData = res.data.items
        this.total = res.data.total
        this.current = name || 1
      })
    }
  }
}
</script>
<style lang='scss' scoped>
@import "../../assets/css/variableName";
@import "../../style/mixin";
[dir='ltr'] .purchase-history {
  .history-tab {
    /deep/ .van-tab {
      //   height: torem(43);
      margin-right: torem(32);
      &:first-child {
        margin-left: 0;
      }
       &:nth-child(5) {
        margin: 0!important;
      }
    }
  }
}
[dir='rtl'] .purchase-history {
  .history-tab {
    /deep/ .van-tab {
      //   height: torem(43);
      margin-left: torem(32);
      &:first-child {
         margin-left: torem(32);
        margin-right: 0;
      }
      &:nth-child(5) {
        margin: 0!important;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
@import "../../assets/css/variableName";
@import "../../style/mixin";
[dir='ltr'] .history-header{
  i{
     float: left;
  }
}
[dir='rtl'] .history-header{
  i{
     float: right;
  }
}
.historyno {
  width: 100%;
  background: #fff;
  height: torem(400);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
  // background: #ccc;
  /deep/ .van-empty__image {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: torem(60);

    svg {
      width: torem(47.42);
      height: torem(50);
    }
  }
}
.purchase-history {
  width: 100%;
  height: 100%;
  // height: 120vh;
  // overflow-y:scroll ;
  background: #fff;
  position: fixed;
  .history-header {
    width: 100%;
    height: torem(44);
    line-height: torem(44);
    padding: 0 torem(16);
    box-sizing: border-box;
    i {
      font-size: torem(18);
     
    }
    font-size: torem(18);
    color: rgba(0, 9, 34, 1);
    text-align: center;
  }
}
.history-main {
  // overflow-y: auto;
  height: 100%;
  display: flex;
  flex-direction: column;
  .data-content {
    // height: 100%;
    padding-bottom: torem(50);
    flex: 1;
    overflow-y: scroll;
    // overflow-y: auto;
  }
  .history-tab {
    padding: 0 torem(16);
    flex-shrink: 0;
    width: torem(375);
    height: torem(43);
    
    /deep/ .van-tab {
      flex: none;
    }
    /deep/.van-tabs {
      height: torem(43);
    }
    /deep/ .van-tab {
      //   height: torem(43);
      // margin-right: torem(32);
      flex-shrink: 0;
      padding: 0;
    
      border-bottom: torem(2) solid transparent;
      &:first-child {
        margin-left: 0;
      }
      &:last-child {
        margin: 0;
      }
    }
    /deep/ .van-tab__text {
      font-size: torem(14);
      height: torem(43);
      line-height: torem(43);
      color: rgba(127, 132, 144, 1);
      font-weight: 400;
      //   padding-bottom: torem(8);
    }
    /deep/ .van-tabs__wrap {
      height: torem(43);
      box-sizing: border-box;
    }
    /deep/ .van-tabs__nav {
      justify-content: space-between;
      padding: 0 ;
      box-sizing: border-box;
    }
    /deep/ .van-tab--active {
      // height: torem(43);
      border-bottom: torem(2) solid rgba(255, 199, 43, 1);
      box-sizing: border-box;
      line-height: torem(42);
      vertical-align: middle;
      .van-tab__text {
        color: rgba(0, 9, 34, 1);
      }
    }
    /deep/ .van-tabs__nav {
      border-bottom: torem(1) solid rgba(239, 239, 239, 1);
    }
    /deep/ .van-tabs__line {
      display: none;
    }
  }

  .joinHistory {
    width: 100vw;
    padding: torem(13) torem(16) 0;
    box-sizing: border-box;
    .listHeader {
      padding: torem(6) 0;
      min-height: torem(26);
      display: flex;
      align-items:flex-start ;
      span {
        color: rgba(127, 132, 144, 1);
        line-height: torem(16);
        font-size: torem(14);
        // vertical-align: text-top;
      }
      margin-bottom: torem(12);
    }
    li {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      min-height: torem(29);
      font-size: torem(14);
      margin-bottom: torem(8);
      padding: torem(3) 0;
      span{
        display: inline-block; 
        width: torem(169.5);
        line-height: torem(16);
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden; //溢出内容隐藏
          text-overflow: ellipsis; //文本溢出部分用省略号表示
          display: -webkit-box; //特别显示模式
          -webkit-line-clamp: 2; //行数
          line-clamp: 2;
          -webkit-box-orient: vertical; //盒子中内容竖直排列 
          &:nth-child(2){
           text-align: end;
          }
      }
     
    }
  }
  .Participated,
  .Refunded,
  .unclaimed,
  .announced {
    width: 100vw;
    padding: torem(13) torem(16) 0;
    box-sizing: border-box;
    .footTip {
      font-size: torem(12);
      color: rgba(127, 132, 144, 1);
      text-align: center;
      margin-top: torem(4);
    }
    .draw {
      color: rgba(0, 180, 100, 1);
      display: flex;
      justify-content: end;
      em{
        font-style: normal;
        width: torem(82);
        display: inline-block;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden; //溢出内容隐藏
        text-overflow: ellipsis; //文本溢出部分用省略号表示
        display: -webkit-box; //特别显示模式
        -webkit-line-clamp: 1; //行数
        line-clamp: 2;
        -webkit-box-orient: vertical; //盒子中内容竖直排列
      }
      i {
        font-size: torem(14);
      }
    }
    .Participated-header,
    .Refunded-header,
    .unclaimed-header,
    .announced-header {
      min-height: torem(26);
      span {
        color: rgba(127, 132, 144, 1);
        line-height: torem(14);
        font-size: torem(14);
        // width: torem(170);
        line-height: torem(16);
          //   font-size: torem(13);
      }
      margin-bottom: torem(12);
    }
    li {
      display: flex;
      align-items: flex-start;
      padding: torem(3) 0;
       margin-bottom: torem(8);
      span {
        font-size: torem(14);
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden; //溢出内容隐藏
        text-overflow: ellipsis; //文本溢出部分用省略号表示
        display: -webkit-box; //特别显示模式
        -webkit-line-clamp: 2; //行数
        line-clamp: 2;
        -webkit-box-orient: vertical; //盒子中内容竖直排列
        width: calc(50% - #{torem(55)});
        line-height: 1.1;
        &:first-child {
          width: torem(110);
        }
        &:nth-child(2){
          padding: 0 torem(4);
        }
        &:last-child {
          text-align: end;
        }
      }
    }
  }
}
/deep/ .van-list__finished-text {
  font-size: torem(12);
  color: rgba(127, 132, 144, 1);
  text-align: center;
  margin-top: torem(4);
}
.tipModel {
  // /deep/ .van-popup {
  width: torem(312);
  min-height: torem(204);
  border-radius: torem(8);
  padding: torem(24);
  // display: flex;
  // justify-content: space-between;
  // flex-direction: column;
  // align-items: center;
  // }
  .p {
    text-align: center;
    svg {
      width: torem(48);
      height: torem(48);
    }
  }
  .describe {
    font-size: torem(14);
    // margin: 0 torem(16);
    text-align: center;
    height: torem(24);
    line-height: torem(24);
    width: 100%;
    margin: torem(16) 0 torem(24);
  }
  .recharge {
    font-size: torem(14);
    width: 100%;
    line-height: torem(21);
    height: torem(21);
    margin: torem(16) 0 torem(24);
    text-align: center;
  }
  .sell {
    /deep/ .van-button {
      width: torem(264);
      height: torem(44);
      background: #ffc72b;
      border-radius: torem(4);
      font-size: torem(16);
      color: #000922;
    }
  }

}
/deep/ .van-empty__description{
  font-size: torem(14);
}
.prizeModel {
  background: transparent;
  .checkGift{
    background: transparent;
    color: #fff;
    font-size: torem(16);
    line-height: torem(16);
    margin: torem(20) auto 0;
    display: block;
  }
  .close {
    text-align: center;
    svg {
      width: torem(28);
      height: torem(28);
      margin: 0 auto;
      // text-align: center;
      margin-top: torem(21);
    }
  }

  .p {
    text-align: center;
    img {
      width: torem(14);
      height: torem(14);
      margin: 0 torem(8);
    }
    font-size: torem(14);
    background: linear-gradient(to right, #d3f6ff, #fffbc9);
    -webkit-background-clip: text;
    color: transparent;
  }
  .shopName {
    font-size: torem(20);
    line-height: torem(23.44);
    background: linear-gradient(to right, #d3f6ff, #fffbc9);
    -webkit-background-clip: text;
    color: transparent;
    text-align: center;
    margin-top: torem(4);
    margin-bottom: torem(24);
  }
  .prizeImage {
    width: torem(278);
    height: torem(211.75);
    img {
      width: torem(278);
      height: torem(211.75);
    }
  }
  .btn {
    // text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-top: torem(47);
    min-height: torem(50);
    >span{
      display: inline-block;
      margin-top: torem(20);
      line-height: torem(16);
      font-size: torem(16);
      color: #fff;
    }
    flex-shrink: 0;
    .van-button {
      width: torem(257);
      height: torem(50);
      // height: 100%;
      font-size: torem(16);
      // line-height: torem(50);
      color: #000922;
      // background: transparent;
      border: none;
      background: url("../../../static/images/btnbackground.png") no-repeat;
      background-size: 100% 100%;
      border-radius: torem(4);
    }
  }
}
  .van-button {
  border: none;
}
</style>


// WEBPACK FOOTER //
// src/view/purchase/historylist.vue